export var NavigationCardContainerOptionType;
(function (NavigationCardContainerOptionType) {
    NavigationCardContainerOptionType["UNIQUE"] = "UNIQUE";
    NavigationCardContainerOptionType["FIRST"] = "FIRST";
    NavigationCardContainerOptionType["MIDDLE"] = "MIDDLE";
    NavigationCardContainerOptionType["LAST"] = "LAST";
})(NavigationCardContainerOptionType || (NavigationCardContainerOptionType = {}));
//# sourceMappingURL=option.js.map